import {createContext, ReactNode, useContext} from 'react';

import {TileId} from './dashboardModel';

const DashboardTileContext = createContext<TileId | undefined>(undefined);

export const DashboardTileProvider = ({
  tileId,
  children,
}: {
  tileId: TileId;
  children: ReactNode;
}) => <DashboardTileContext.Provider value={tileId}>{children}</DashboardTileContext.Provider>;

export const useDashboardTileId = (): TileId | undefined => useContext(DashboardTileContext);
